import dataReducer from './data';
import selectionsReducer from './selections';

const reducers = {
  data: dataReducer,
  selections: selectionsReducer,
};

export default reducers;
